<template>
  <v-layout>
    <v-flex md12 sm12>
      <v-card>
        <v-card-title>
          世界 Boss 列表
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addNew">新增 Boss</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="bossList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.bossImageURL="{ item }">
              <img :src="item.bossImageURL" height="50" v-if="item.bossImageURL" />
            </template>
            <template v-slot:item.isDefeated="{ item }">
              {{ item.isDefeated ? '是' : '否' }}
            </template>
            <template v-slot:item.enable="{ item }">
              {{ item.enable ? '是' : '否' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                :color="Theme.GREEN"
                class="white--text"
                @click="editBoss(item)"
              >
                編輯
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <!-- Boss Detail Dialog -->
    <boss-detail
      :visible="editView.visible"
      :title="editView.title"
      :item-detail="editView.item"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
    />
  </v-layout>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";
import BossDetail from "./BossDetail.vue";

export default {
  name: "world-boss",
  components: {
    BossDetail
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      bossList: [],
      headers: [
        { text: "Boss 圖示", value: "bossImageURL", sortable: false },
        { text: "Boss 名稱", value: "bossName" },
        { text: "最大血量", value: "maxHealth" },
        { text: "當前血量", value: "currentHealth" },
        { text: "獎品名稱", value: "prizeName" },
        { text: "獎品數量", value: "quantity" },
        { text: "已擊敗", value: "isDefeated" },
        { text: "啟用狀態", value: "enable" },
        { text: "操作", value: "actions", sortable: false }
      ],
      editView: {
        visible: false,
        title: "",
        item: null,
        cancelEvent: () => {
          this.editView.visible = false;
        },
        confirmEvent: () => {
          this.editView.visible = false;
          this.loadBossData();
        }
      }
    };
  },
  created() {
    this.loadBossData();
  },
  methods: {
    ...mapActions(["getBossList", "saveBossInfo"]),
    
    async loadBossData() {
      try {
        this.loading = true;
        const res = await this.getBossList({
          pageIndex: 1,
          limit: 10,
          searchQuery: []
        });

        const result = res.data;
        if (result && result.statusCode === 0) {
          this.bossList = result.data.list || [];
        } else {
          this.showMessageDialog("錯誤", "獲取 Boss 資料失敗");
        }
      } catch (e) {
        console.error("loadBossData error:", e);
        this.showMessageDialog("錯誤", "載入資料時發生錯誤");
      } finally {
        this.loading = false;
      }
    },

    addNew() {
      this.editView.title = "新增 Boss";
      this.editView.item = {
        bossId: "",
        bossName: "",
        bossImageURL: "",
        tip: "",
        maxHealth: 0,
        prizeName: "",
        prizeImageURL: "",
        quantity: 0,
        backgroundURL: "",
        intro: "",
        recyclePrice: 0,
        bonus: 0,
        productId: "world",
        enable: false
      };
      this.editView.visible = true;
    },

    editBoss(item) {
      this.editView.title = "編輯 Boss";
      this.editView.item = item;
      this.editView.visible = true;
    },

    showMessageDialog(title, content) {
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    }
  }
};
</script>

<style scoped></style>
